import React from "react";
import BlogPost from "../components/BlogPost";
import "../styles/containers/Blog.css";
import PropTypes from "prop-types";

// takes in json of blog posts from App
// responsible for feeding the data into individual BlogPosts
const Blog = (props) => {
  const parseBlogPosts = () => {
    const allPosts = props.posts.map((post) => {
      return (
        <div key={post.id}>
          <article>
            <BlogPost
              id={post.id}
              title={post.title}
              date={post.date}
              body={post.body}
            />
          </article>
          <hr />
        </div>
      );
    });
    return allPosts;
  };

  const postList = parseBlogPosts();
  return <div>{postList}</div>;
};

Blog.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
    })
  ),
};

export default Blog;
